<template lang="pug">
v-navigation-drawer.NavigationNotificationMenu.notification-menu(
  :value="isOpenCloseNotificationMenu",
  v-bind="$attrs",
  v-on="$listeners",
  fixed,
  right,
  temporary,
  touchless,
  light,
  ref="notificationDrawer"
)
  .notification-menu-header
    h4 Notifications
    a.close-btn(
      href="#"
      @click.prevent="setOpenCloseNotificationMenu(false)"
    )
      SolidCloseIcon.svg-icon
  NotificationsListAll(
    ref="notificationList",
    @click.native="onNotificationClick"
  )
  v-btn.small-text.bottom-btn(
    color="#9D9C9C",
    outlined,
    block
    to="/profile/notifications",
    @click.native="setOpenCloseNotificationMenu(false)"
  )
    SolidListUlIcon.svg-icon.small-icon.list-ul-icon.fill-gray.mr-1
    | View All
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NotificationsListAll from 'Components/NotificationsList/NotificationsListAll';
import SolidCloseIcon from 'images/svg-icons/solid-close.svg';
import SolidListUlIcon from 'images/svg-icons/solid-list-ul.svg';
import { VNavigationDrawer } from 'vuetify/lib';
import { scrollToTop } from 'Helpers/utils/view';

export default {
  name: 'NavigationNotificationMenu',
  components: {
    NotificationsListAll,
    SolidCloseIcon,
    SolidListUlIcon,
    VNavigationDrawer,
  },
  computed: {
    ...mapGetters('view', [
      'isOpenCloseNotificationMenu',
    ]),
    isOpenNotificationMenu() {
      return this.$refs.notificationDrawer
        ? this.$refs.notificationDrawer.showOverlay : this.isOpenCloseNotificationMenu;
    },
  },
  watch: {
    isOpenNotificationMenu() {
      if (!this.isOpenNotificationMenu) {
        if (this.$refs.notificationDrawer && this.$refs.notificationDrawer.$el.children[0]) {
          scrollToTop(0, this.$refs.notificationDrawer.$el.children[0]);
        }
        this.setOpenCloseNotificationMenu(false);
      }
      const html = document.getElementsByTagName('html')[0];
      if (this.isOpenNotificationMenu) {
        html.classList.add('is-notification-menu-open');
      } else html.classList.remove('is-notification-menu-open');
    },
  },
  methods: {
    ...mapActions('view', [
      'setOpenCloseNotificationMenu',
    ]),
    onNotificationClick(event) {
      const { target } = event;
      // Close notification window if clicked on link
      if (target instanceof HTMLAnchorElement) {
        this.setOpenCloseNotificationMenu(false);
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.notification-menu
  width: 413px !important
  height: 100%
  top: 65px !important
  background: $white
  box-shadow: 0 1px 15px 0 rgba(0,0,0,0.05)
  border-radius: 2px
  z-index: 5
  border-bottom-left-radius: 5px
  border-bottom-right-radius: 5px
  @media screen and (max-width: 991px)
    display: none
  &-header
    background-color: $primary
    text-align: center
    padding: 10px
    height: 50px
    width: 100%
    display: flex
    justify-content: center
    position: absolute
    left: 0
    z-index: 2
    top: 0
    h4
      color: $white
    .close-btn
      position: absolute
      top: 15px
      right: 15px
      .svg-icon
        width: 23px
        height: 23px
        +mt(.3s)
        g
          stroke: $white
          stroke-opacity: 1
      &:hover
        .svg-icon
          opacity: 0.8
          +mt(.3s)
  .notifications
    width: 100%
    padding-top: 75px
    padding-left: 10px
    padding-right: 10px
    padding-bottom: 100px
    position: relative
    ::v-deep .notifications-content__date
      font-size: 14px
      line-height: 20px
      padding: 10px 0
      text-transform: capitalize
      +font(600)
    ::v-deep .notifications-header
      // position: relative
      justify-content: space-between
      h3
        font-size: 17px
        line-height: 26px
        width: 268px
        flex-shrink: 0
        margin-bottom: 0
      .mark-read
        position: absolute
        top: 85px
        right: 15px
      &.is-notification
        margin-bottom: 10px
        .mark-read
          top: 78px
    ::v-deep .notification-item
      border: 1px solid $support_lightgray
      align-items: flex-start
      padding: 20px 10px
      margin: 10px 0
      border-radius: 2px
      &:before
        display: none
      .notification-item-icon
        margin-right: 10px
        &:before
          display: none
        .notification-item-icon__wrap
          border: 1px solid $support_lightgray
          box-shadow: none
      .notification-item-content
        border: none
        padding: 0
        flex-direction: column
        align-items: flex-start
        .notification-item-content__time
          margin-left: 0
          margin-top: 10px
          flex-direction: row
          .date
            margin-right: 5px
            font-family: $font-semibold
        .notification-item-content__new
          right: 10px
          bottom: 10px
          top: auto
        *:not(.notification-item-content__new)
          font-family: $font-medium
          font-weight: 500
          font-size: 12px
          line-height: 19px
          a
            font-weight: 600
            font-family: $font-semibold
          strong
            +font(600)
        &__status
          top: auto
          bottom: 0px
          right: 0px
      &.is-new
        box-shadow: 0 2px 15px 0 rgba(0,0,0,0.05)
        .notification-item-content
          box-shadow: none
    ::v-deep .notifications-btn-row-read
      padding-top: 10px
      padding-bottom: 20px
      &:before
        display: none
      .v-btn
        margin-left: 0
    ::v-deep .mark-read
      width: 100%
      display: flex
      justify-content: flex-end
      top: 10px
      &__text
        font-size: 12px
        line-height: 19px
      &__circle
        width: 16px
        height: 16px
        &--svg
          width: 17px
          height: 17px
        &--svg-icon
          width: 8px
          height: 6px
  .bottom-btn
    position: absolute
    bottom: 65px
    width: 100%
    z-index: 1
</style>
